import React, { createContext, useContext, useEffect, useState } from "react";
import { gaAddToCart } from "./analytics";

const CartContext = createContext(null);
const KEY = "camino_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    gaAddToCart(item);
    setItems((prev) => {
      if (item.kind === "etching") {
        const idx = prev.findIndex((p) => p.kind === "etching" && p.product_slug === item.product_slug);
        if (idx >= 0) {
          const copy = [...prev];
          const cap = item.inventory ?? copy[idx].inventory ?? Infinity;
          const nextQty = Math.min(cap, copy[idx].quantity + (item.quantity || 1));
          copy[idx] = { ...copy[idx], quantity: nextQty, inventory: item.inventory ?? copy[idx].inventory };
          return copy;
        }
      }
      return [...prev, { ...item, line_id: Date.now() + Math.random(), quantity: item.quantity || 1 }];
    });
  };

  const removeItem = (line_id) => setItems((prev) => prev.filter((p) => p.line_id !== line_id));
  const updateQty = (line_id, quantity) =>
    setItems((prev) => prev.map((p) => {
      if (p.line_id !== line_id) return p;
      const cap = p.inventory ?? Infinity;
      return { ...p, quantity: Math.min(cap, Math.max(1, quantity)) };
    }));
  const clear = () => setItems([]);

  const count = items.reduce((n, i) => n + i.quantity, 0);
  const subtotal = items.reduce((n, i) => n + i.price * i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
